import ShiftsTable from '@/app/shifts'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import {
  shiftsByCompanyIdQueryOptions,
  shiftsByUserIdQueryOptions,
} from '@/hooks/useShiftsQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <ShiftsTable />
}

export const Route = createFileRoute('/_auth/_withProject/shifts')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Vardiyalar')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { user, isSecurity } = context.auth
    const { queryClient } = context
    const companyId = LocalStorage.selectedCompany()?.id

    if (!user && !(user as any)?.position) return {}

    if (isSecurity) {
      await queryClient.prefetchQuery(shiftsByUserIdQueryOptions(user?.id ?? 0))
    } else if (isSecurity === false || !isSecurity) {
      await queryClient.prefetchQuery(shiftsByCompanyIdQueryOptions(companyId))
    }
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


